const a = "_animated_6z2qw_1", t = "_whiteQuadrant_6z2qw_1", r = "_primaryCircle_6z2qw_4", e = {
  animated: a,
  whiteQuadrant: t,
  primaryCircle: r
};
export {
  a as animated,
  e as default,
  r as primaryCircle,
  t as whiteQuadrant
};
//# sourceMappingURL=index.es2448.js.map
